export default ({ list = [], currentIndex = 0 } = {}) => {
  return list[(currentIndex - 1 + Object.values(list).length) % Object.values(list).length];
};
